import { createReducer } from 'utilities';
import * as TYPES from './constants';

const initialState = {
  elements: {},
  ids: [],
  quantity: 0,
};

const reducer = createReducer(initialState, {
  [TYPES.CART_UPDATE](state, { cart }) {
    return {
      ...cart,
      quantity: cart.ids.reduce((acc, id) => acc + cart.elements[id].$quantity, 0)
    };
  },
  [TYPES.CART_CLEAR]() {
    return initialState;
  }
});

export default reducer;


// WEBPACK FOOTER //
// ./src/ducks/cart/reducer.js